import React from 'react';
export function ReframeSection() {
  return <section className="py-20 bg-brand-teal text-white" data-id="element-183">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-8" data-id="element-185">
          El problema no sos vos.
        </h2>

        <div className="space-y-6 text-lg text-brand-sand/90 leading-relaxed" data-id="element-186">
          <p className="text-xl font-medium text-white" data-id="element-187">
            Es que la facultad te enseñó la teoría.
          </p>

          <p data-id="element-188">Nadie te dio el sistema para la práctica real.</p>

          <p data-id="element-189">
            Nadie te explicó cómo armar una primera consulta de 60 minutos que
            realmente capte todo lo que necesitás saber. Nadie te enseñó a
            interpretar un análisis de sangre más allá de los valores de
            referencia del laboratorio. Nadie te dio el protocolo FODMAP
            completo en las tres fases con los productos que se consiguen en el
            súper de la vuelta de tu consultorio.
          </p>

          <p data-id="element-190">
            Nadie te dijo cuánto cobrar ni cómo decirle el precio al paciente
            sin disculparte.
          </p>

          <p className="text-2xl font-serif font-bold text-white mt-8 pt-8 border-t border-brand-tealLight" data-id="element-191">
            Eso es exactamente lo que construimos.
          </p>
        </div>
      </div>
    </section>;
}